class PaymentButtons {
    constructor() {
        this.forms = [];
        this.isProcessing = false;
    }

    init() {
        this.bindForms();
    }

    bindForms() {
        this.forms = document.querySelectorAll('.payment-form');

        this.forms.forEach(form => {
            form.addEventListener('submit', (e) => this.handleSubmit(e, form));
        });
    }

    handleSubmit(event, currentForm) {
        // Prevenir múltiples envíos
        if (this.isProcessing) {
            event.preventDefault();
            return;
        }

        this.isProcessing = true;
        this.disableAllButtons(currentForm);
    }

    disableAllButtons(activeForm) {
        const allButtons = document.querySelectorAll('.payment-form button[type="submit"]');

        allButtons.forEach(button => {
            button.disabled = true;

            // Agregar spinner y cambiar texto del botón activo
            if (button.closest('form') === activeForm) {
                this.setButtonLoading(button);
            } else {
                // Otros botones solo se deshabilitan visualmente
                button.classList.add('opacity-50');
            }
        });
    }

    setButtonLoading(button) {
        const icon = button.querySelector('i');

        // Guardar contenido original
        button.dataset.originalContent = button.innerHTML;

        // Cambiar contenido del botón
        button.innerHTML = `
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Procesando...
        `;
    }
}

export default new PaymentButtons();
